module.exports = __webpack_public_path__ + "static/media/Jean Furlan Headshot_1585144692561.f62f368c.jpg";